export const navigationItems = [
  { id: "accueil", label: "Accueil", to: "/" },
  { id: "applications", label: "Applications", to: "/applications" },
  { id: "tarifs", label: "Tarifs", to: "tarifs" },
  { id: "apropos", label: "À propos", to: "apropos" },
];

export const authButtons = [
  {
    id: "login",
    label: "Se connecter",
    to: "/login",
    variant: "ghost",
  },
  {
    id: "register",
    label: "S'inscrire",
    to: "/register",
    variant: "primary",
  },
];

export const logoConfig = {
  primaryText: 'Easy',
  secondaryText: 'Suite',
  primaryColor: '#FF8D28',
  secondaryColor: '#000000',
  to: '/',
};
